import { Component, ViewContainerRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ModalComponent } from "../../../modal/modal.component";
import { AdvancedFilterComponent } from "../../../advanced-filter/advanced-filter.component";
import { TableListRequest } from "../../../../models/table-list-request.interface";
import { NoDataComponent } from "../../../no-data/no-data.component";
import { NoDataFoundComponent } from "../../../no-data-found/no-data-found.component";
import { ResizableModule, ResizeEvent } from "angular-resizable-element";
import { SvgIconComponent } from "../../../svg-icon/svg-icon.component";
import { TableMenuComponent } from "../../../table-menu/table-menu.component";
import { PaginatedListDataResponse } from "../../../../models/paginated-list-data-response";
import { LoadingService } from "../../../../services/loading.service";
import { OperationService } from "../../../../services/operations.service";
import { User } from "../../../../models/user.interface";
import { SharedModule } from "../../../../modules/shared/shared.module";
import { InventoryService } from "../../../../services/inventory-service";
import { HighlightPipe } from "../../../../pipes/highlight.pipe";
import vehiclePageConfig from "../config/vehicle-page-config.json";
import { TableMeta } from "../../../../models/table-meta.interface";
import { TosTableComponent } from "../../../tos-table/tos-table.component";

@Component({
  selector: 'app-container-listing',
  standalone: true,
  imports: [
    FormsModule, 
    SharedModule,
    SvgIconComponent,
    HighlightPipe,
    TableMenuComponent,
    ResizableModule,
    NoDataFoundComponent,
    NoDataComponent,
    TosTableComponent
  ],
  templateUrl: './vehicle-listing.component.html',
  styleUrl: './vehicle-listing.component.scss'
})
export class VehicleListingComponent {
  protected readonly vehiclePageConfig = vehiclePageConfig;
  tableMeta!: TableMeta;
  
  filterFields = [
      {
        displayName: 'Container Number',
        key: 'containerNo',
      }
    ];
    isFilterApplied: boolean = false;
    searchTerm: any;
    focusSearch!: boolean;
    tableLoaded: boolean = false;
    tableListData: PaginatedListDataResponse = {
      totalCount: 0,
      page: 0,
      limit: 0,
      records: []
    };
    sortColumn: string = "modifiedDate";
    openMenuIndex: number | null = null;
    menuOptions = [
      { label: 'Edit', value: 'edit' },
      { label: 'View', value: 'view' },
    ];
    totalTablePages: number = 0;
    currentTablePage: number = 1;
    sortDirection: "asc" | "desc" = "desc";
    rowsPerPage: number = 25;
    currentPage: number = 0;
    tableListRequest: TableListRequest = {
      selectFields: [
        "id",
        "trailerNumber",
        "transporterId",
        "vehicleTypeId",
        "processCycle",
        "gateInDate",
        "modifiedDate",
      ],
      orderBy: {
        [this.sortColumn]: this.sortDirection
      },
      limit: this.rowsPerPage,
      page: this.currentPage
    };
    allTableRecordsSelected: boolean = false;
    selectedItems: any[] = [];
    previousTerm: string = "";
  
    constructor(private viewContainerRef: ViewContainerRef,
                private loadingService: LoadingService,
                private inventoryService: InventoryService) {
                this.tableMeta = vehiclePageConfig.vehicleTableConfig;

    }
  
    ngOnInit(){
      this.fetchAllRecords()
    }
  
    fetchAllRecords() {
      this.loadingService.show();
      this.inventoryService.getVehicleList(this.tableListRequest).subscribe({
        next: (res: any) => {
          this.tableListData = res.data;
          this.calculateTotalPages();
          this.tableLoaded = true;
          this.loadingService.hide()
  
        },
        error: (error: Error) => {
          console.error("Error occurred:", error);
          this.tableLoaded = false;
          this.loadingService.hide()
        }
      });
    }
  
 
  
    private clearSelection() {
      this.selectedItems = [];
    }
  
    private refreshTableList() {
      this.fetchAllRecords()
    }
  

  
    isAllRecordsOfCurrentPageSelected() {
      return (
        this.allTableRecordsSelected ||
        (this.tableListData.records?.length > 0 &&
          this.tableListData.records?.every((item: User) =>
            this.isSelected(item)
          ))
      );
  
    }
  
    toggleAllRecordsOfCurrentPageSelections(checked: any) {
      if (checked) {
        this.tableListData.records?.forEach((item) => {
          if (!this.isSelected(item)) {
            this.selectedItems.push(item);
          }
        });
      } else {
        this.tableListData.records?.forEach((item) => {
          this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);
        });
      }
    }
  
    onResizeEnd(event: ResizeEvent, column: string) {
      if (event.edges.right) {
        const columnHeader = document.querySelector(`th.${column}_th`) as HTMLElement;
        const columnCells = document.querySelectorAll(`td.${column}_td`);
        const newWidth = `${event.rectangle.width}px`;
  
        if (columnHeader) {
          columnHeader.style.width = newWidth;
        }
  
        columnCells.forEach(cell => {
          const cellHtml = cell as HTMLElement;
          cellHtml.style.width = newWidth;
        });
      }
    }
  

  
    isSelected(item: any) {
      if (this.allTableRecordsSelected) {
        return true;
      } else {
        const recordIdx = this.selectedItems.findIndex((x) => x.id === item.id);
        if (recordIdx !== -1) {
          return true;
        } else {
          return false;
        }
      }
    }
  
    toggleSelection(item: any) {
      if (!this.isSelected(item)) {
        this.selectedItems.push(item);
      } else {
        this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);
      }
    }
  
    handleMenuToggle(i: number) {
      this.openMenuIndex = this.openMenuIndex === i ? null : i;
    }
  
    handleOptionSelected(record: any) {
      console.log(record);
      const recordId = record.id;
    }
  
 
  
    calculateTotalPages() {
        this.totalTablePages = Math.ceil(
          (this.tableListData?.totalCount || 50) / this.rowsPerPage
        );
    }
  

}
